@if (pressable) {
  <button type="button" class="pill" (click)="pressed.emit()">
    <ng-container [ngTemplateOutlet]="body" />
  </button>
} @else {
  <span class="pill" role="status">
    <ng-container [ngTemplateOutlet]="body" />
  </span>
}

<ng-template #body>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <rect x="5" y="10.5" width="14" height="9.5" rx="2.2" />
    @if (icon === 'locked') {
      <!-- A closed shackle: nothing is open. -->
      <path d="M8.2 10.5V8a3.8 3.8 0 0 1 7.6 0v2.5" />
    } @else {
      <!-- The same shackle, swung open: the space is unlocked right now. -->
      <path d="M8.2 10.5V8a3.8 3.8 0 0 1 7.2-1.6" />
    }
  </svg>
  <span>{{ label }}</span>
</ng-template>
